import { Action } from 'redux'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'

const changeChildrenCount = (
  count: number,
  formName,
): IChangeChildrenCount => ({
  count,
  formName,
  type: ReservationModalActions.ChangeChildren,
})

export interface IChangeChildrenCount
  extends Action<ReservationModalActions.ChangeChildren> {
  count: number
  formName: string
}

export default changeChildrenCount
